export const ARI_REASON_CODES = {
  AVAILABLE: {
    label: "Available",
    color: "#3AD189",
  },
  INVALID_PRICING: {
    label: "Invalid Rates",
    color: "#EF4444",
  },
  MISSING_ARI: {
    label: "Missing Data",
    color: "#F97316",
  },
  NO_AVAILABILITY_NO_INVENTORY: {
    label: "No Inventory",
    color: "#EAB308",
  },
  NO_AVAILABILITY_W_INVENTORY: {
    label: "No Availability",
    color: "#F59E0B",
  },
};

export const getReasonCodeLabel = (reasonCode) => {
  return ARI_REASON_CODES[reasonCode]?.label || reasonCode;
};

export const getReasonCodeColor = (reasonCode) => {
  return ARI_REASON_CODES[reasonCode]?.color || "#6B7280";
};
